import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EChartsInitOpts, EChartsOption } from 'echarts';

@Component({
    selector: 'app-radial-echart',
    templateUrl: './radial-echart.component.html',
    styleUrls: ['./radial-echart.component.css']
})
export class RadialEchartComponent implements OnInit {
    @Input() public series: any[];
    @Input() public tooltips: string[];

    public emphasisStyle = {
        disabled: true,
        itemStyle: {
            shadowBlur: 0,
            shadowColor: 'rgba(0,0,0,0.3)'
        }
    };

    public initOptions: EChartsInitOpts = {
        renderer: 'svg'
    };

    public chartOptions: EChartsOption = {
        color: [
            '#6979ed',
            '#ebf0f7'
        ],
        tooltip: {
            z: 60,
            show: true,
            showContent: true,
            alwaysShowContent: false,
            displayMode: 'single',
            renderMode: 'auto',
            confine: null,
            showDelay: 0,
            hideDelay: 100,
            transitionDuration: 0.4,
            enterable: false,
            backgroundColor: '#fff',
            shadowColor: 'rgba(0, 0, 0, .2)',
            shadowOffsetX: 1,
            shadowOffsetY: 2,
            borderRadius: 4,
            borderWidth: 1,
            padding: null,
            extraCssText: '',
            className: 'echart-tooltip',
            trigger: 'item',
            formatter: '{b}'
        },
    };

    public constructor(
        public translateService: TranslateService,
    ) {}

    public ngOnInit(): void {
        this.chartOptions.series = [{
            type: 'pie',
            radius: ['75%', '100%'],
            // center: ['50%', '110%'],
            padAngle: 3,
            itemStyle: {
                borderRadius: 3
            },
            // startAngle: 0,  // 180
            // endAngle: 360,    // 360
            labelLine: {
                show: false
            },
            label: {
                show: false,
            },
            data: this.series.map((item, index) => ({
                value: item, name: this.tooltips[index]
            })),
            emphasis: this.emphasisStyle
        }];
    }
}
